<div class="sales-route-control">
  <div *ngIf="layerHidden && stops.length" class="br-text-muted br-small br-fst-italic br-mb-2">
    Layer hidden — use the eye above to draw it.
  </div>

  <ng-container *ngIf="stops.length === 0; else plan">
    <p class="br-text-muted br-small br-mb-2">
      No day planned. The route is built on its own page — plan a day there and
      the stops appear here and on the map, in driving order.
    </p>
  </ng-container>

  <ng-template #plan>
    <div class="br-text-muted br-small br-mb-1">{{ stops.length }} stops</div>
    <!-- Read-only on purpose: reordering, visiting and finishing a day are the
         page's job, and a half-controls panel would invite the wrong one. -->
    <ol class="stop-list br-mb-2">
      <li *ngFor="let stop of stops" class="stop-row" [title]="stop.title || 'Stop ' + stop.seq">
        <span class="stop-seq" [style.background-color]="stop.color">{{ stop.seq }}</span>
        <span class="stop-title">{{ stop.title || 'Untitled stop' }}</span>
      </li>
    </ol>
  </ng-template>
</div>
